import gql from 'graphql-tag';

import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {PipelineStepFragment as PipelineStepFragmentType} from './__generated/PipelineStepFragment';
import {PipelineStepDataFragment} from './PipelineStepDataFragment';
import {PipelineStepEdgeFragment} from './PipelineStepEdgeFragment';

export const PIPELINE_STEP_FRAGMENT = gql`
  fragment PipelineStepFragment on PipelineStepDomainNode {
    id
    config
    incomingEdges {
      ...PipelineStepEdgeFragment
    }
    inputStepDatas {
      ...PipelineStepDataFragment
    }
    outgoingEdges {
      ...PipelineStepEdgeFragment
    }
    outputStepDatas {
      ...PipelineStepDataFragment
    }
    isRerunnable
    nonRerunnableReason
    statusCode
    statusMessage
    stepType
    stepVersion
  }

  ${PipelineStepDataFragment.fragment}
  ${PipelineStepEdgeFragment.fragment}
`;

export const PipelineStepFragment: FragmentWrapper<PipelineStepFragmentType> = {
  fragment: PIPELINE_STEP_FRAGMENT,
  fragmentName: 'PipelineStepFragment',
};
